import { Routes, Route, Navigate } from 'react-router-dom';
import { DocumentProvider } from './contexts/DocumentContext';
import PrivateRoute from './components/auth/PrivateRoute';
import AuthenticatedRoute from './components/auth/AuthenticatedRoute';
import SubscriptionRoute from './components/auth/SubscriptionRoute';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import HomePage from './pages/HomePage';
import DashboardPage from './pages/DashboardPage';
import UploadPage from './pages/UploadPage';
import EditorPage from './pages/EditorPage';
import SendPage from './pages/SendPage';
import SignPage from './pages/SignPage';
import CompletePage from './pages/CompletePage';
import ViewDocumentPage from './pages/ViewDocumentPage';
import NotFoundPage from './pages/NotFoundPage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import VerifyPage from './pages/VerifyPage';
import MigrationPage from './pages/MigrationPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import TestFunctionsPage from './pages/TestFunctionsPage';
import SubscriptionPage from './pages/SubscriptionPage';
import SubscriptionSuccessPage from './pages/SubscriptionSuccessPage';
import DatabaseResetPage from './pages/DatabaseResetPage';
import AccountPage from './pages/AccountPage';
import ContractGeneratorPage from './pages/ContractGeneratorPage';
import './App.css';

function App() {
  return (
    <DocumentProvider>
      <Header />
      <main className="main-content">
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          
          {/* Routes that don't require authentication */}
          <Route path="/sign/:documentId" element={<SignPage />} />
          <Route path="/complete/:documentId" element={<CompletePage />} />
          <Route path="/verify" element={<VerifyPage />} />
          <Route path="/auth/callback" element={<Navigate to="/login" replace />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-of-service" element={<TermsOfServicePage />} />
          <Route path="/404" element={<NotFoundPage />} />
          <Route path="/test-functions" element={<TestFunctionsPage />} />
          
          {/* Protected routes that only require authentication */}
          <Route path="/dashboard" element={<PrivateRoute><DashboardPage /></PrivateRoute>} />
          <Route path="/account" element={<PrivateRoute><AccountPage /></PrivateRoute>} />
          <Route path="/migrate" element={<PrivateRoute><MigrationPage /></PrivateRoute>} />
          <Route path="/subscription" element={<PrivateRoute><SubscriptionPage /></PrivateRoute>} />
          <Route path="/subscription/success" element={<PrivateRoute><SubscriptionSuccessPage /></PrivateRoute>} />
          <Route path="/database-reset" element={<PrivateRoute><DatabaseResetPage /></PrivateRoute>} />
          
          {/* Protected routes that require subscription */}
          <Route path="/upload" element={<SubscriptionRoute><UploadPage /></SubscriptionRoute>} />
          <Route path="/editor/:documentId" element={<SubscriptionRoute><EditorPage /></SubscriptionRoute>} />
          <Route path="/send/:documentId" element={<SubscriptionRoute><SendPage /></SubscriptionRoute>} />
          <Route path="/view/:documentId" element={<SubscriptionRoute><ViewDocumentPage /></SubscriptionRoute>} />
          <Route path="/contracts/generate" element={<SubscriptionRoute><ContractGeneratorPage /></SubscriptionRoute>} />
          
          {/* Fallback route */}
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>
      </main>
      <Footer />
    </DocumentProvider>
  );
}

export default App;
